/**
 * 모바일 채팅 오버레이 컴포넌트
 * MainLayoutWithChat에서 분리하여 파일 크기 최적화
 */
import React from 'react';
import styled from '@emotion/styled';
import { ChatModal, ChatProvider } from '@edusense/ai-chat';
import { PeopleChatModal } from '@edusense/people-chat';

// 모바일 채팅 오버레이 스타일
const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${props => props.isOpen ? 'block' : 'none'};
  opacity: ${props => props.isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const Container = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--theme-paper, #ffffff);
  z-index: 1000;
  transform: translateX(${props => props.isOpen ? '0' : '100%'});
  transition: transform 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

interface MobileChatOverlayProps {
  isOpen: boolean;
  chatType: 'ai' | 'people';
  onClose: () => void;
  onSwitchToAIChat: () => void;
  onSwitchToUserChat: () => void;
}

export const MobileChatOverlay: React.FC<MobileChatOverlayProps> = ({
  isOpen,
  chatType,
  onClose,
  onSwitchToAIChat,
  onSwitchToUserChat
}) => {
  return (
    <>
      <Overlay 
        isOpen={isOpen} 
        onClick={onClose}
      />
      <Container isOpen={isOpen}>
        {chatType === 'ai' ? (
          <ChatProvider>
            <ChatModal
              isOpen={true}
              onClose={onClose}
              isSidebarMode={false}
              onSwitchToUserChat={onSwitchToUserChat}
            />
          </ChatProvider>
        ) : (
          <PeopleChatModal
            onSwitchToAIChat={onSwitchToAIChat}
            onClose={onClose}
          />
        )}
      </Container>
    </>
  );
};